import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";

// Response interface following architecture patterns
export interface FilestackConfigResponse {
  apiKey: string;
}

// Service function following architecture patterns
export const FilestackConfigApiService =
  async (): Promise<FilestackConfigResponse> => {
    const url = "/filestack/config";
    const { data } = await axios.get(url);
    return data;
  };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useFilestackConfigApiService = () =>
  useQuery<FilestackConfigResponse, AxiosError, FilestackConfigResponse>(
    ["FilestackConfigApiService"],
    () => FilestackConfigApiService()
  );

export default useFilestackConfigApiService;
